<div class="app-content"> 
    <modulo-header></modulo-header>
    <router-outlet></router-outlet>
    <modulo [page]="page" posicao="whatsapp" template="fixo"></modulo>
    <modulo posicao="contato" template="two"></modulo>  
    <footer-partial></footer-partial> 
</div>    
